import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const RedirectHandling = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { pathname } = location;

  switch (pathname) {
    case "/admin":
      window.location.href = `${process.env.REACT_APP_API_URL}/admin`;
      break;
    case "/teaching":
      window.location.href = `${process.env.REACT_APP_API_URL}/teaching`;
      break;
    default:
      navigate("/404");
  }
  return <div />;
};

export default RedirectHandling;
